import ApiEventProduct from 'types/api/EventProduct';

import Model from 'models/Model';
import Product from 'models/Product';

import { changeFromCent } from 'utils/math';

export default class EventProduct implements Model {
    id: string;
    price: number;
    product: Product;

    constructor(data: ApiEventProduct) {
        this.id = data.id;
        this.price = data.price && changeFromCent(data.price) || 0;
        this.product = data.product && new Product(data.product);
    }

    getName = (): string => {
        return this.product.productBodyParts[0]?.bodyPart?.name ?? this.product.locale.name;
    };
}
